import { h, defineAsyncComponent } from 'vue'

const UpsellView = defineAsyncComponent(() => import('@/modules/Upsell/UpsellView.vue'))

export const upsellInstances = [
	{
		id: 'upsell-static-subscription-activated',
		config: () => import('@/modules/Upsell/instances/static/upsell-static-subscription-activated'),
	},

	{
		id: 'upsell-static-assessment-result',
		config: () => import('@/modules/Upsell/instances/static/upsell-static-assessment-result'),
	},

	{
		id: 'upsell-f',
		config: () => import('@/modules/Upsell/instances/upsell-f'),
	},
	{
		id: 'upsell-m',
		config: () => import('@/modules/Upsell/instances/upsell-m'),
	},

	{
		id: 'upsell-activity-f',
		config: () => import('@/modules/Upsell/instances/upsell-activity-f'),
	},
	{
		id: 'upsell-activity-m',
		config: () => import('@/modules/Upsell/instances/upsell-activity-m'),
	},

	{
		id: 'upsell-yoga-f',
		config: () => import('@/modules/Upsell/instances/upsell-yoga-f'),
	},
	{
		id: 'upsell-yoga-m-us',
		config: () => import('@/modules/Upsell/instances/upsell-yoga-m-us'),
	},

	{
		id: 'upsell-tai-chi-walking-f',
		config: () => import('@/modules/Upsell/instances/upsell-tai-chi-walking-f'),
	},
	{
		id: 'upsell-tai-chi-move-f',
		config: () => import('@/modules/Upsell/instances/upsell-tai-chi-move-f'),
	},

	{
		id: 'upsell-calisthenics-m',
		config: () => import('@/modules/Upsell/instances/upsell-calisthenics-m'),
	},
	{
		id: 'upsell-military-calisthenics-m',
		config: () => import('@/modules/Upsell/instances/upsell-military-calisthenics-m'),
	},
	{
		id: 'upsell-military-calisthenics-sh-m',
		config: () =>
			import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-military-calisthenics-sh-m'),
	},
	{
		id: 'upsell-military-calisthenics-f',
		config: () => import('@/modules/Upsell/instances/upsell-military-calisthenics-f'),
	},
]

const instancesRoutes = upsellInstances.map((instance) => ({
	path: `/upsell/${instance.id.replace('upsell-', '')}`,
	name: instance.id,
	component: {
		render: () =>
			h(UpsellView, {
				key: instance.id,
				id: instance.id,
				config: instance.config,
			}),
	},
	meta: {
		requiresUser: true,
	},
}))

export default instancesRoutes
